module.exports = "/virtual-football-league/img/amblems/right/Spain/Fake_AtleticoBilbao.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/Spain/Fake_AtleticoBilbao.png
// module id = 2148
// module chunks = 4